import axios from "axios"
import { URL_API } from "@/helpers"

// Headers
const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  Context: window.location.toString(),
}

export default axios.create({
  baseURL: URL_API,
  headers,
})
